if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
        this.quickAddPriceCleanup = null;

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.quickAddPriceCleanup?.();
        this.quickAddPriceCleanup = null;
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info');

            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);
            this.initializeQuickAddPriceUpdates();

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            // Initialize gallery arrows after content is loaded
            this.initializeGalleryArrows();

              if (window.initProductMediaTabs) {
                window.initProductMediaTabs(this.modalContent);
              }

              setTimeout(() => {
                if (window.refreshPopupMediaGallery) {
                  window.refreshPopupMediaGallery(this.modalContent);
                }
              }, 120);

              super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
       /* const newId = `quickadd-${sectionId}`;*/
          const newId = oldId;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
    
        
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }

      // initializeGalleryArrows() {
      //   // Wait for the next tick to ensure DOM is fully rendered
      //   setTimeout(() => {
      //     const modalContent = this.modalContent;
          
      //     // Find arrow buttons within the modal
      //     const nextButton = modalContent.querySelector('.pdp_button-next');
      //     const prevButton = modalContent.querySelector('.pdp_button-prev');
          
      //     if (!nextButton || !prevButton) return;

      //     // Scoped functions that work within the modal context
      //     const goToNextSlide = () => {
      //       let activeLi = modalContent.querySelector('.thumbnail-list__item.is-active');
      //       if (!activeLi) {
      //         const withCurrent = modalContent.querySelector('.thumbnail-list__item [aria-current="true"]');
      //         if (withCurrent) activeLi = withCurrent.closest('.thumbnail-list__item');
      //       }
      //       if (!activeLi) return;
      //       let nextLi = activeLi.nextElementSibling;
      //       // Include all media (images and videos) when using arrows—do not skip hidden items
      //       if (nextLi) {
      //         activeLi.classList.remove('is-active');
      //         nextLi.classList.add('is-active');
      //         nextLi.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      //         const button = nextLi.querySelector('button');
      //         if (button) button.click();
      //       }
      //     };

      //     const goToPrevSlide = () => {
      //       let activeLi = modalContent.querySelector('.thumbnail-list__item.is-active');
      //       if (!activeLi) {
      //         const withCurrent = modalContent.querySelector('.thumbnail-list__item [aria-current="true"]');
      //         if (withCurrent) activeLi = withCurrent.closest('.thumbnail-list__item');
      //       }
      //       if (!activeLi) return;
      //       let prevLi = activeLi.previousElementSibling;
      //       // Include all media (images and videos) when using arrows—do not skip hidden items
      //       if (prevLi) {
      //         activeLi.classList.remove('is-active');
      //         prevLi.classList.add('is-active');
      //         prevLi.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      //         const button = prevLi.querySelector('button');
      //         if (button) button.click();
      //       }
      //     };

      //     // Attach event listeners to the buttons
      //     nextButton.addEventListener('click', goToNextSlide);
      //     prevButton.addEventListener('click', goToPrevSlide);
      //   }, 100);
      // }
      initializeGalleryArrows() {
      setTimeout(() => {
        const modalContent = this.modalContent;

        const nextButton = modalContent.querySelector('.pdp_button-next');
        const prevButton = modalContent.querySelector('.pdp_button-prev');

        if (!nextButton || !prevButton) return;

        const getVisibleThumbs = () => {
          return Array.from(modalContent.querySelectorAll('.thumbnail-list__item')).filter((item) => {
            return !item.hidden && window.getComputedStyle(item).display !== 'none';
          });
        };

        const setActiveThumb = (targetLi) => {
          if (!targetLi) return;

          const allThumbs = modalContent.querySelectorAll('.thumbnail-list__item');
          allThumbs.forEach((li) => {
            li.classList.remove('is-active');
            const btn = li.querySelector('button');
            if (btn) btn.removeAttribute('aria-current');
          });

          targetLi.classList.add('is-active');
          const btn = targetLi.querySelector('button');
          if (btn) {
            btn.setAttribute('aria-current', 'true');
            btn.click();
          }
        };

        const goToNextSlide = () => {
          const visibleThumbs = getVisibleThumbs();
          if (!visibleThumbs.length) return;

          let activeLi = visibleThumbs.find((li) => li.classList.contains('is-active'));
          if (!activeLi) {
            const withCurrent = visibleThumbs.find((li) => li.querySelector('[aria-current="true"]'));
            if (withCurrent) activeLi = withCurrent;
          }

          if (!activeLi) {
            setActiveThumb(visibleThumbs[0]);
            return;
          }

          const currentIndex = visibleThumbs.indexOf(activeLi);
          const nextIndex = currentIndex + 1 < visibleThumbs.length ? currentIndex + 1 : currentIndex;

          setActiveThumb(visibleThumbs[nextIndex]);
          visibleThumbs[nextIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        };

        const goToPrevSlide = () => {
          const visibleThumbs = getVisibleThumbs();
          if (!visibleThumbs.length) return;

          let activeLi = visibleThumbs.find((li) => li.classList.contains('is-active'));
          if (!activeLi) {
            const withCurrent = visibleThumbs.find((li) => li.querySelector('[aria-current="true"]'));
            if (withCurrent) activeLi = withCurrent;
          }

          if (!activeLi) {
            setActiveThumb(visibleThumbs[0]);
            return;
          }

          const currentIndex = visibleThumbs.indexOf(activeLi);
          const prevIndex = currentIndex - 1 >= 0 ? currentIndex - 1 : currentIndex;

          setActiveThumb(visibleThumbs[prevIndex]);
          visibleThumbs[prevIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        };

        nextButton.replaceWith(nextButton.cloneNode(true));
        prevButton.replaceWith(prevButton.cloneNode(true));

        const freshNextButton = modalContent.querySelector('.pdp_button-next');
        const freshPrevButton = modalContent.querySelector('.pdp_button-prev');

        freshNextButton.addEventListener('click', goToNextSlide);
        freshPrevButton.addEventListener('click', goToPrevSlide);
      }, 100);
    }

      initializeQuickAddPriceUpdates() {
        this.quickAddPriceCleanup?.();
        this.quickAddPriceCleanup = null;

        const productInfo = this.modalContent.querySelector('product-info');
        if (!productInfo) return;

        const quantityInput = productInfo.querySelector('.quantity__input');
        const priceTarget = productInfo.querySelector('.kik_price_amount');
        if (!quantityInput || !priceTarget) return;

        const listeners = [];
        const addListener = (element, event, handler, options) => {
          if (!element) return;
          element.addEventListener(event, handler, options);
          listeners.push(() => element.removeEventListener(event, handler, options));
        };

        const getUnitPriceCents = () => {
          const salePrice = productInfo.querySelector('.price__sale .price-item--sale .money');
          const regularPrice = productInfo.querySelector('.price__regular .price-item--regular .money');
          const priceElement = salePrice || regularPrice;
          if (!priceElement) return null;
          return this.parseMoneyToCents(priceElement.textContent);
        };

        const updateTotalPrice = () => {
          const unitPriceCents = getUnitPriceCents();
          if (unitPriceCents === null) return;

          const quantity = parseInt(quantityInput.value, 10);
          const qty = Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
          const totalCents = unitPriceCents * qty;

          const formatted = this.formatMoneyFromCents(totalCents);
          if (formatted === null) return;

          priceTarget.innerHTML = formatted.includes('<span')
            ? formatted
            : `<span class="money">${formatted}</span>`;
        };

        addListener(quantityInput, 'change', updateTotalPrice);
        addListener(quantityInput, 'input', updateTotalPrice);

        productInfo.querySelectorAll('.quantity__button').forEach((button) => {
          addListener(button, 'click', () => window.setTimeout(updateTotalPrice, 50));
        });

        const priceContainer = productInfo.querySelector('.price');
        let priceObserver;
        if (priceContainer) {
          priceObserver = new MutationObserver(() => updateTotalPrice());
          priceObserver.observe(priceContainer, { childList: true, subtree: true, characterData: true });
        }

        updateTotalPrice();

        this.quickAddPriceCleanup = () => {
          listeners.forEach((off) => off());
          priceObserver?.disconnect();
        };
      }

      parseMoneyToCents(value) {
        if (!value) return null;

        const cleanedValue = value
          .replace(/[^0-9,.-]/g, '')
          .replace(/\s/g, '')
          .trim();

        if (!cleanedValue) return null;

        const usesCommaAsDecimal = cleanedValue.lastIndexOf(',') > cleanedValue.lastIndexOf('.');

        let normalized = cleanedValue;
        if (usesCommaAsDecimal) {
          normalized = normalized.replace(/\./g, '').replace(/,/g, '.');
        } else {
          normalized = normalized.replace(/,/g, '');
        }

        const amount = Number.parseFloat(normalized);
        if (!Number.isFinite(amount)) return null;

        return Math.round(amount * 100);
      }

      formatMoneyFromCents(cents) {
        if (!Number.isFinite(cents)) return null;

        if (window.Shopify && typeof Shopify.formatMoney === 'function') {
          const formatString =
            (window.Shopify.currency && window.Shopify.currency.active && window.Shopify.money_with_currency_format) ||
            window.Shopify.money_format ||
            '${{amount}}';
          return Shopify.formatMoney(cents, formatString);
        }

        const currency = window.Shopify?.currency?.active || 'USD';
        try {
          return (cents / 100).toLocaleString(undefined, { style: 'currency', currency });
        } catch (error) {
          return `${currency} ${(cents / 100).toFixed(2)}`;
        }
      }
    }
  );
}
